import { Component, OnInit, PLATFORM_ID, Inject, ViewChild, ViewContainerRef, Injector, NgModuleFactoryLoader, NgModuleFactory, Renderer2, ApplicationRef, Compiler } from '@angular/core';
import { Router } from '@angular/router';
import { UrlService } from '@app/services/url.service';
import { isPlatformBrowser } from '@angular/common';
import { StorageService } from '@app/services/storage.service';
import { Title, Meta } from '@angular/platform-browser';
import { HtmlContentService } from '@app/services/html-content.service';
import { environment } from '@env/environment';
declare let loadBootsrtapNative: Function;

@Component({
  selector: 'app-sms-seo',
  templateUrl: './sms-seo.component.html',
  styleUrls: ['./sms-seo.component.css']
})
export class SmsSeoComponent implements OnInit {

  @ViewChild('recharge_steps_section', { static: true, read: ViewContainerRef }) rechargeStepsSection: ViewContainerRef;

  isPromotion = false;
  notificationEnabled = false;
  interval: number;
  loadModules = false;

  routerLinkRecarga = '/';
  routerLinkSms = '/sms-a-cuba';
  routerLinkNauta = '/recargas-nauta';

  stepRecharge: boolean;

  private _componentRef;

  title = 'Envía «【 SMS a Cuba 】» por solo 0.04 centavos con Cubatel 🥇';
  description = 'Envía «【 SMS a Cuba 】» por solo 0.04 centavos con Cubatel desde el exterior ✅ Mensajes al instante para familiares y amigos en Cuba ➤ ¡Pincha AQUÍ!';
  keywords='enviar sms a cuba, sms a cuba, sms to cuba, sms gratis a cuba sin registrarse, sms para cuba';
  url = this.router.url;//new URL(window.location.href).toString();

  constructor(
    private router: Router,
    private urlService: UrlService,
    private storageService: StorageService,
    private promotionService: HtmlContentService,
    private titleService: Title,
    private metaService: Meta,
    private _injector: Injector,
    private _viewRef: ViewContainerRef,
    private _renderer: Renderer2,
    private _compiler: Compiler,
    private _applicationRef: ApplicationRef,
    @Inject(PLATFORM_ID) private platformId,

  ) {
    if (this.storageService.isAuthenticated()) {
      this.routerLinkRecarga = '/recargas';
      this.routerLinkSms = '/sms';
      this.routerLinkNauta = '/nauta';
    }

  }

  ngOnInit() {
    this.metaService.updateTag({ name: 'description', content: this.description });
    this.metaService.updateTag({ name: 'keywords', content: this.keywords });
    this.metaService.updateTag({ name: 'robots', content: 'all' });
    this.metaService.updateTag({ property: 'og:title', content: this.title });
    this.metaService.updateTag({ property: 'og:description', content: this.description });
    this.metaService.updateTag({ property: 'og:url', content: `${environment.host}${this.router.url}` });

   this.titleService.setTitle(this.title);

    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0);
      loadBootsrtapNative();
      document.addEventListener('scroll', (e) => {
        if (!this.loadModules) {
          this.loadModule();
          this.loadModules = true;
        }
      }, {
        passive: true
      });
    }
    this.storageService.currentUser.subscribe(user => {
      if (this.storageService.isAuthenticated()) {
        this.routerLinkRecarga = '/recargas';
        this.routerLinkSms = '/sms';
        this.routerLinkNauta = '/nauta';
      } else {
        this.routerLinkRecarga = '/';
        this.routerLinkSms = '/sms-a-cuba';
        this.routerLinkNauta = '/recargas-nauta';
      }
    });
    this.promotionService.contentPromotion
      .subscribe(result => {
        if (result.isPreRechargeEnabled || result.isPromotionEnabled) {
          this.isPromotion = true;
        }
      });
    this.promotionService.contentNotification
      .subscribe((result: any) => { if (result) { this.notificationEnabled = result.notificationEnabled; } });
    this.urlService.changeUrl(this.router.url);
    this.urlService.footer.emit();
  }

  signUp() {
    this.storageService.logout();
    this.storageService.authorizeSubject.next({ 'authorize': false, 'url': '/' });
  }

  loadModule() {
    import('@app/recharge-steps/recharge-steps.module')
      .then((module) => module[Object.keys(module)[0]])
      .then((module) => this._compiler.compileModuleAsync(module))
      .then((factory) => {
        const moduleRef = factory.create(this._injector);
        const component = (moduleRef as any)._bootstrapComponents[0];
        this._componentRef = moduleRef.componentFactoryResolver.resolveComponentFactory(component).create(this._injector, [], null, moduleRef);
        // Set component input variables
        this.storageService.loadLoginSubject.next(false);
        this._applicationRef.attachView(this._componentRef.hostView);
        this._applicationRef.attachView(this._componentRef.hostView);
        this._renderer.appendChild(this._viewRef.element.nativeElement, this._componentRef.location.nativeElement);
      });
  }

}
